class CollaboratorsSlider extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
        this.container = this.querySelector('.swiper-container');
        this.pagination = this.querySelector('.swiper-pagination');
        if (!this.container) {
            console.error('[CollaboratorsSlider] .swiper-container not found');
            return;
        }
        if (!window.Swiper) {
            console.error('[CollaboratorsSlider] Swiper is not loaded on window');
            return;
        }
        const slides = this.container.querySelectorAll('.swiper-slide');
        this.initOrDestroySwiper();
        window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }

    handleResize() {
        this.initOrDestroySwiper();
    }

    initOrDestroySwiper() {
        const isMobile = window.innerWidth < 750;
        if (isMobile && !this.swiper) {
            try {
                this.swiper = new window.Swiper(this.container, {
                    direction: 'vertical',
                    slidesPerView: 1,
                    spaceBetween: 24,
                    autoHeight: true,
                    pagination: {
                        el: this.pagination,
                        clickable: true
                    },
                });
            } catch (e) {
                console.error('[CollaboratorsSlider] Swiper initialization error:', e);
            }
        } else if (!isMobile && this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }
}

customElements.define('collaborators-slider', CollaboratorsSlider);